module.exports = __webpack_public_path__ + "img/companie-logo.300ae625.png";